import * as React from 'react';
import { UserAgreement } from './login/UserAgreement';
import { Input, Icon, Button, Row, Col, message } from 'antd';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import '../css/Login.scss';
import service from '../service/apolloclient.service';
import LocalStorage from '../service/localstorage';
import { MSGDISPLAYTIME } from './common/constants';
import strings from '../eyeguide-localization/strings.login';
import { staticProperties, STATICKEYS }  from './common/staticProperties';

const logo = require('../images/logo.svg');

interface IloginState {
  username: string;
  password: string;
  toMain: boolean;
  showTC: boolean;
  flag: boolean;
  check: boolean;
  loading: boolean;
  inputDisabled: boolean;
  isModalVisible: boolean;
}

class Login extends React.Component<{}, IloginState> {
  
  constructor(props: React.ReactPropTypes) {
    super(props);
    this.state = {
      username: '',
      password: '',
      toMain: false,
      showTC: false,
      flag: false,
      check: true,
      loading: false,
      inputDisabled: false,
      isModalVisible: false
    };
    staticProperties.set(STATICKEYS.rerender, true);
  }

  async submit() {

    this.setState({ loading: true , inputDisabled: true});
    
    if (this.state.check) {
      let storage = new LocalStorage();
      storage.setUsername(this.state.username !== undefined ? this.state.username : '');
    }

    let ser = new service();    
    await ser.login(this.state.username, this.state.password)
     .then( res => {
        console.log('login response', res);
        this.initializeLocalstorage(res);  
        this.intitializeWidget(false);              
        document.title = 'EyeGuide';
        localStorage.removeItem('daterange');      
        this.setState({
          toMain: res.showTC ? false : true,
          showTC: res.showTC
        });
        if (this.state.showTC) {
          this.showUpdatePasswordModal();
        }
      })
     .catch( e => {
        this.setState({ loading: false , inputDisabled: false});
        this.initializeLocalstorage({});
        console.log('login error', e);
        message.error(strings.lsLoginFailedTxt, MSGDISPLAYTIME); 
    });
  }

  render() {
    if (this.state.toMain === true) {
      return ( <Redirect to="/dashboard" /> );
    } else if (this.state.showTC) {
      return ( 
                <UserAgreement
                  isModalVisible={this.state.isModalVisible}
                  modalClosed={() => this.setState({isModalVisible: false})}
                />
            );
    }
    return (
      <div className="Login"> 
        <div className="container">
          <Row>
            <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
            <Col xs={20} sm={16} md={12} lg={8} xl={6}>
              <div className="logoContainer"><img className="logo" src={logo} /></div>
            </Col>
            <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
          </Row>
          <Row className="signInTitle">
            <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
            <Col xs={20} sm={16} md={12} lg={8} xl={6}>
              <h2 className="logoContainer">{strings.lsSignInTitle}</h2>
            </Col>
            <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
          </Row>
          <div>
            <Row className="labelRow">
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
              <Col xs={10} sm={11} md={5} lg={4} xl={3}>
                <span> {strings.lsAccountIdTxt} </span>
              </Col>
              <Col xs={10} sm={11} md={7} lg={4} xl={3} style={{textAlign: 'right'}}>
                  <Link  to="/forgotUsername">{strings.lsForgotUsernameTxt}</Link>
              </Col>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
            </Row>
            <Row>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
              <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                <Input 
                  name="phoneInput"
                  prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  className="username" 
                  placeholder={strings.lsAccountIDPlaceholderTxt}
                  value={this.state.username}
                  tabIndex={1}
                  onChange={ 
                    e => this.handleUsernameChange(e) 
                  }
                  disabled={this.state.inputDisabled}
                  autoFocus={true}
                />
              </Col>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
            </Row>
          </div>
          <div className="passwordContainer"> 
            <Row className="labelRow">
              <Col xs={2} sm={1} md={6} lg={8} xl={9}/>
              <Col xs={10} sm={11} md={5} lg={4} xl={3}>
                <span> {strings.lsPasswordPlaceholderTxt} </span>
              </Col>
              <Col xs={10} sm={11} md={7} lg={4} xl={3} style={{textAlign: 'right'}}>
                  <Link  to="/forgotPassword">{strings.lsForgotPasswordTxt}</Link>
              </Col>
              <Col xs={2} sm={1} md={4} lg={8} xl={9}/>
            </Row>
            <Row>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
              <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                <Input 
                  prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  className="password" 
                  placeholder={strings.lsPasswordPlaceholderTxt}
                  type="password" 
                  value={this.state.password}
                  tabIndex={2}
                  onChange={ 
                    e => this.handlePasswordChange(e) 
                  }
                  onPressEnter={
                    e => this.submit()
                  }
                  disabled={this.state.inputDisabled}
                />
              </Col>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
            </Row>
          </div>
          {/* <div className="forgotPasswordContainer"> 
            <Row>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
              <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Checkbox onChange={e => this.handleCheckbox(e)}>{strings.lsRememberMeTxt}</Checkbox>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} style={{textAlign: 'right'}}>
                  <Link to="/">{strings.lsForgotPasswordTxt}</Link>
                </Col>
              </Col>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
            </Row>
          </div> */}
          <div className="signinContainer"> 
            <Row>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
              <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                  <Button 
                    className="signin" 
                    type="primary" 
                    loading={this.state.loading}
                    onClick={e => {
                        this.submit();      
                      }
                    }
                    tabIndex={3}
                  >
                    {strings.lsSignInTxt}
                  </Button>
                </Col>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
            </Row>
          </div>
        </div>
        <div className="footer">
          <Row>
            <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
            {/*<Col xs={7} sm={6} md={3} lg={3} xl={2} style={{textAlign: 'left'}}>
              <Link to="/privacy" className="footerLinks">{strings.lsPrivacyPolicyTxt}</Link>
            </Col>
            <Col xs={5} sm={5} md={5} lg={2} xl={2} style={{textAlign: 'center'}}>
              <Link to="/terms" className="footerLinks">{strings.lsTermsTxt}</Link>
            </Col>*/}
            <Col 
                xs={20} 
                sm={16} 
                md={12} 
                lg={8} 
                xl={6}  
            >
              <Link to="/contactus" className="footerContactLink">{strings.lsContactTxt}</Link>
            </Col>
            <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
          </Row>
          <Row>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
              <Col 
                xs={20} 
                sm={16} 
                md={12} 
                lg={8} 
                xl={6} 
                className="footerLinks copyright"
              >
                  {strings.lsFooterCopyrightTxt}
              </Col>
              <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
            </Row>
        </div>
      </div> 
    );
  }

  componentDidMount() {
    document.title = 'Sign in to EyeGuide · EyeGuide';
    strings.setLanguage(navigator.language);
    this.initializeLocalstorage({});
    this.intitializeWidget();
    let storage = new LocalStorage();
    this.setState({username: storage.getUsername()});
  }

  private intitializeWidget(hide: any = true) {     
    function loadLogOutScript() {
      if ('zE' in window) {
        const widgetHide = document.createElement('script');        
        if (hide) {
          widgetHide.text = 'zE(\'webWidget\', \'clear\');';
          widgetHide.text += ' zE(\'webWidget\', \'hide\');';
        } else {
          widgetHide.text += ' zE(\'webWidget\', \'show\');';
        }
        console.log('widgetHide: ', widgetHide.text); 
        document.body.appendChild(widgetHide);
      }       
      return Promise.resolve({});      
    }

    loadLogOutScript().then(() => { console.log('widget logged out.'); });
  }

  private showUpdatePasswordModal() {
        this.setState({
            isModalVisible: true
        });
  }

  private initializeLocalstorage(res: any) {
    let storage = new LocalStorage();
    storage.setToken(res.token !== undefined ? res.token : ''); 
    storage.setZendeskSSOToken(res.zESSOToken);  
    storage.setZendeskWidgetToken(res.zEWidgetToken);  
    console.log('initializeLocalstorage', res);
    let token = this.decodeToken(res.token);
    console.log('token', token);
    storage.setFirstName(res.firstname !== undefined ? res.firstname : '');
    storage.setLastName(res.lastname !== undefined ? res.lastname : '');
    storage.setUid(res.uid !== undefined ? res.uid : '');
    storage.setVersion(res.version !== undefined ? res.version : '');
    storage.setTemplateName(res.templatename !== undefined ? res.templatename : '');
    // storage.setRoleID(res.roleid !== undefined ? res.roleid : '');
    storage.setUser(token !== undefined && token.user !== undefined ? token.user : '');
    storage.setOrganizationName(res.primaryorganizationname !== undefined ? res.primaryorganizationname : '');
    storage.setSelectedOrg('');
    storage.setSelectedOrgName('');
    storage.setSelectedOrgPrimary('');
  }

  private handleUsernameChange(event: React.FormEvent<HTMLInputElement>) {
    this.setState({username: event.currentTarget.value});
  }

  private handlePasswordChange(event: React.FormEvent<HTMLInputElement>) {
    this.setState({password: event.currentTarget.value});
  }

  // private handleCheckbox(event: any) {
  //   this.setState({check: (this.state.check ? false : true)});
  // }

  private decodeToken(token: any) {
    if (token !== undefined) {
      let base64Url = token.split('.')[1];   
      if (base64Url) { 
      let base64 = base64Url.replace('-', '+').replace('_', '/');
      return JSON.parse(window.atob(base64));
      } else {
        return '';
      }
    }
  }
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/Login.tsx